import { defineComponent } from 'vue';
import VcomProvider from '../../../../../../VcomProvider';
export default defineComponent({
    name: 'Illustration',
    compatConfig: {
        MODE: 3,
    },
    props: {
        illustration: {
            type: Object,
            required: true,
        },
    },
    computed: {
        source() {
            const isLightMode = VcomProvider.Layout.getTheme() === 'mcflat';
            const file = isLightMode ? this.illustration.imageLight : this.illustration.imageDark;
            return `${this.illustration.path}/${file}`;
        },
    },
});
